import React, { useCallback, useMemo } from 'react';
import { statusEnum } from '@utils/status';
import { Col, Row } from 'antd';
import moment from 'moment';
import Actives from '@pages/Insights/Dashboard/Actives';
import OnlineOrOffline from '@pages/Insights/Dashboard/OnlineOrOffline';
import StatusLines from '@pages/Insights/Dashboard/StatusLines';

const LinesInfo = ({ setSearchParams, filters, handleChange }: any) => {
  const handleLastConnection = useCallback(
    (days: number) => {
      const today = moment().endOf('day');
      const from = moment().subtract(days, 'days').startOf('day');
      setSearchParams({
        status: undefined,
        online: undefined,
        lastConnectionFrom: from.toISOString(),
        lastConnectionTo: today.toISOString(),
      });
      handleChange(
        'last-connection',
        true,
        `${from.toISOString()}/${today.toISOString()}`,
      );
    },
    [setSearchParams, handleChange],
  );

  const cols = useMemo(
    () => [
      {
        key: '1',
        content: (
          <Actives
            onClick={() => {
              setSearchParams({ online: undefined, status: statusEnum.ACTIVE });
              handleChange('status', true, statusEnum.ACTIVE);
            }}
            filters={filters}
          />
        ),
      },
      {
        key: '2',
        content: (
          <OnlineOrOffline
            isOnline
            onClick={() => {
              setSearchParams({
                online: 'true',
                status: undefined,
              });
              handleChange('online', true, 'true');
            }}
            filters={filters}
          />
        ),
      },
      {
        key: '3',
        content: (
          <StatusLines
            onClick={days => handleLastConnection(days)}
            filters={filters}
            allowMultiple
          />
        ),
      },
    ],
    [handleLastConnection, setSearchParams, filters, handleChange],
  );

  return (
    <Row gutter={[8, 8]} style={{ paddingBottom: 16 }}>
      {cols?.map(col => (
        <Col key={col.key} xl={8} lg={12} xs={24}>
          {col.content}
        </Col>
      ))}
    </Row>
  );
};

export default LinesInfo;
